// dependencies
import { format } from "date-fns";
import React, { useMemo } from "react";

import Text from "../../../../../../components/Text";
// components
import { CardBody, CardHeader } from "../../../../components/Card";
import FactorsPolygonChart from "../../../../components/FactorsPolygonChart";
// hooks
import useFactorsPolygonChart from "../../../../components/FactorsPolygonChart/useFactorsPolygonChart";

// store
import useStore from "../../../../store";

// css
import css from "./FactorsPolygon.module.scss";

const FactorsPolygonCard = () => {
	// setup
	const [filter, month] = useStore((state) => [state.filter, state.overview.month]);

	const { orderedDataSets, isLoadingData, hasError } = useFactorsPolygonChart({ filter, month: month || undefined });

	const selectionChip = useMemo(() => {
		const cohortLabel = "All Employees";
		if (month) {
			return (
				<div className={css.selectionChip}>
					<Text element="span" size="caption" weight="semi-bold">
						{cohortLabel}
					</Text>
					<Text element="span" size="caption" weight="regular">
						{` ${format(month, "LLLL yyyy")}`}
					</Text>
				</div>
			);
		} else {
			return null;
		}
	}, [month]);

	return (
		<div>
			<CardHeader
				title={
					<span>
						<Text element="span" size="paragraph-2" weight="semi-bold">
							Satisfaction Factors
						</Text>
					</span>
				}
				info="The radar chart displays the factors contributing to the overall satisfaction score for the selected period."
				toolBar={selectionChip}
			/>
			<CardBody>
				<div className={css.factorsPolygon}>
					<FactorsPolygonChart
						orderedDataSets={orderedDataSets}
						isLoadingData={isLoadingData}
						hasError={hasError}
					/>
				</div>
			</CardBody>
		</div>
	);
};

export default FactorsPolygonCard;
